import React from 'react';
import NavItem from '../common/navitem';
import './navbar.css';
import decor from '../../assets/icons/navbar-decor.svg';

const NavBar = (props) => {
    return ( 
        <>
        <header>
            <img src={decor} alt="diamond shape" />
            <div className="line"></div>
            <nav>
                <ul>
                    <NavItem section="#hero" navitem="Home" />
                    <NavItem section="#life" navitem="Life" />
                    <NavItem section="#works" navitem="Works" />
                    <NavItem section="#themes" navitem="Themes" />
                    <NavItem section="#quotes" navitem="Quotes" />
                    <NavItem section="#footer" navitem="Footer" />
                </ul>
            </nav>
            <div className="line"></div>
            <img src={decor} alt="diamond shape" />
        </header>
        </>
     );
}
 
export default NavBar;